import React, { useState } from "react";
import {
  CheckCircle2,
  Calendar,
  Clock,
  ArrowRight,
  UserCheck,
  FileText,
  ArrowLeft,
} from "lucide-react";
import { useParams } from "react-router-dom";
import { LayoutMain } from "../LayoutMain";

export const FinConsulta = () => {
  const [fechaHoy] = useState(
    JSON.parse(localStorage.getItem("auth")).confApp.fechas,
  );
  const {
    pacienteAtendido,
    nombreDoctor,
    specialty,
    proxFecha,
    proxHora,
    idPaciente,
    proxPaciente,
    telefono,
    espacio,
  } = useParams();

  const nextAppointment = {
    fecha: proxFecha,
    hora: proxHora,
    idPaciente: idPaciente,
    paciente: proxPaciente,
    espacio: espacio,
    telefono: telefono,
  };

  const backToDashboard = () => {
    window.location.href = "/#/Home/Dashboard";
  };

  const iniciaConsulta = () => {
    const getCita = {
      idConsulta: 0,
      espacio: espacio,
      idPac: nextAppointment.idPaciente,
      nombre: nextAppointment.paciente,
      fecha: fechaHoy.fechaFmtUsa,
      hora: nextAppointment.hora,
      telefono: nextAppointment.telefono,
      precio: 0,
    };

    localStorage.setItem("getCita", JSON.stringify(getCita));
    window.location = `/#/Home/Dashboard/Consulta/${nextAppointment.espacio}`;
  };

  return (
    <LayoutMain titleItem="FinConsulta" selectedKey="Dashboard">
      <div className="bg-slate-50 flex items-center justify-center p-4 sm:p-6">
        <div className="max-w-2xl w-full bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
          {/* Banner de confirmación */}
          <div className="bg-emerald-50 border-b border-emerald-100 p-6 text-center">
            <div className="mx-auto w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-3">
              <CheckCircle2 className="w-7 h-7 text-emerald-600" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900">
              Consulta Finalizada con Éxito
            </h1>
            <p className="text-slate-600 text-sm mt-1">
              Se ha registrado el historial clínico y la nota médica
              correctamente.
            </p>
          </div>

          <div className="p-6 space-y-6">
            {/* Detalles resumidos de la consulta */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-slate-50 p-4 rounded-xl border border-slate-100">
              <div className="flex items-start gap-3">
                <UserCheck className="w-5 h-5 text-slate-400 mt-0.5" />
                <div>
                  <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                    Paciente
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    {pacienteAtendido}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <FileText className="w-5 h-5 text-slate-400 mt-0.5" />
                <div>
                  <p className="text-xs font-medium text-slate-500 uppercase tracking-wide">
                    Atendido por
                  </p>
                  <p className="text-sm font-semibold text-slate-800">
                    {nombreDoctor}
                  </p>
                  <p className="text-xs text-slate-500">{specialty}</p>
                </div>
              </div>
            </div>

            {/* Siguiente Cita (Sección Destacada) */}
            <div className="border border-blue-100 bg-blue-50/50 rounded-xl p-5">
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs font-bold uppercase tracking-wider text-blue-700 bg-blue-100 px-2.5 py-1 rounded-full">
                  Próxima Cita Programada
                </span>
                <span className="text-xs text-blue-600 font-medium">
                  {nextAppointment.fecha !== "-" ? "Consulta confirmada" : "No hay próximas citas programadas"}
                </span>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3 bg-white p-3 rounded-lg border border-blue-100 shadow-2xs">
                  <Calendar className="w-5 h-5 text-blue-600" />
                  <div>
                    <p className="text-xs text-slate-500">Fecha</p>
                    <p className="text-sm font-semibold text-slate-800">
                      {nextAppointment.fecha}
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-3 bg-white p-3 rounded-lg border border-blue-100 shadow-2xs">
                  <Clock className="w-5 h-5 text-blue-600" />
                  <div>
                    <p className="text-xs text-slate-500">Hora</p>
                    <p className="text-sm font-semibold text-slate-800">
                      {nextAppointment.hora}
                    </p>
                    <p className="text-xs text-slate-500">
                      {nextAppointment.paciente}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Botones de acción */}
            <div className="pt-2 space-y-3 sm:space-y-0 sm:flex sm:gap-3">
              <button
                type="button"
                onClick={backToDashboard}
                className="w-full sm:w-1/2 flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                Volver al Inicio
              </button>

              <button
                type="button"
                onClick={iniciaConsulta}
                disabled={nextAppointment.fecha === "-" ? true : false}
                className="w-full sm:w-1/2 flex items-center justify-center gap-2 px-4 py-2.5 bg-blue-600 rounded-lg text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
              >
                Iniciar siguiente consulta
                <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </LayoutMain>
  );
};
